import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function RoleUsers(props) { 

    const [ users, setUsers ] = useState([]);

    const GetUsers = () => { 
        axios.post('http://localhost:5000/Roles/RoleUsers', { id: props.id})
            .then((response) => { 
                setUsers(response.data);
            })
            .catch((error) => { 
                console.log(error);
            })
    }

    useEffect(() => { 
        GetUsers();
    });

    useEffect(() => { 
        GetUsers();
    }, [users]);

    return(
        <React.Fragment>
            {
                [...Array((users.length))].map((e, i) =>
                    <>{users[i].firstName}, </>
                )
            }
        </React.Fragment>
    )

}